import React from "react";
import { Snackbar } from "@mui/material";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

const DEFAULT_MESSAGE =
  "Opa, verificamos algo de errado com a sua Internet. Verifique sua conexão.";

const CustonSnackbar = ({
  message,
  open,
  handleClose,
  severity = "error",
}: SnackBarProps) => {
  if (message.toString().includes("Network Error")) {
    message = DEFAULT_MESSAGE;
  }

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      ContentProps={{
        "aria-describedby": "message-id",
      }}
    >
      <MuiAlert
        variant="standard"
        onClose={handleClose}
        severity={severity}
        sx={{ width: "100%" }}
      >
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default CustonSnackbar;

export type SnackBarProps = {
  // Message to display inside the box
  message: string;
  // Indicates whether the Snackbar is open or closed
  open: boolean;
  // Callback function to handle Snackbar closure
  handleClose: () => void;
  // What type of alert to display
  severity?: AlertProps["severity"];
};
